const ACTIVATE_TAB = 'scratch-gui/navigation/ACTIVATE_TAB';
const TABS_ACTIVE = 'scratch-gui/navigation/TABS_ACTIVE';
const SHOWMENUSTAGE = 'scratch-gui/targets/showmenustage';

// Constants use numbers to make it easier to work with react-tabs
const BLOCKS_TAB_INDEX = 0;
const COSTUMES_TAB_INDEX = 1;
const SOUNDS_TAB_INDEX = 2;

const TABS_ACTIVE_INDEX = 0;

const initialState = {
    activeTabIndex: BLOCKS_TAB_INDEX,
    tabsActiveIndex: TABS_ACTIVE_INDEX,
    showMenuStage:"block"
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case ACTIVATE_TAB:
        return Object.assign({}, state, {
            activeTabIndex: action.activeTabIndex
        });
    case TABS_ACTIVE:
        return Object.assign({},state,{
            tabsActiveIndex : action.tabsActiveIndex
        });
    case SHOWMENUSTAGE:
        return Object.assign({}, state, {
            showMenuStage: action.showMenuStage
        });
    default:
        return state;
    }
};

const activateTab = function (tab) {
    return {
        type: ACTIVATE_TAB,
        activeTabIndex: tab
    };
};

const tabsActive = function (tab) {
    return {
        type: TABS_ACTIVE,
        tabsActiveIndex: tab
    };
};

const setShowMenuStage = function(stage){
    return {
        type: SHOWMENUSTAGE,
        showMenuStage: stage,
    };
}

export {
    reducer as default,
    initialState as editorTabInitialState,
    activateTab,
    tabsActive,
    BLOCKS_TAB_INDEX,
    COSTUMES_TAB_INDEX,
    SOUNDS_TAB_INDEX,
    setShowMenuStage
};
